// Turns a pasted YouTube/Vimeo link into an embeddable iframe src. Shared by
// the Topic builder, Exercise template builder, and canvas VIDEO_EMBED nodes
// (VideoEmbedPreview.jsx) - kept as one function so every surface embeds a
// given link the same way. Ported identically (same regexes) into
// english-app's TypeScript so a link embeds the same on both sides.
export function resolveVideoEmbedUrl(rawUrl) {
   if (!rawUrl) return null;
   const url = rawUrl.trim();
   let m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{6,15})/);
   if (m) return { provider: 'youtube', embedUrl: 'https://www.youtube.com/embed/' + m[1] };
   m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
   if (m) return { provider: 'vimeo', embedUrl: 'https://player.vimeo.com/video/' + m[1] };
   return null;
}
